// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pathFill":"_1Hl-4m","dash":"_3w2f_7"};